export { default } from "./ClassPassDetail";

